import type { User } from '@common/types/objects';

export const CORE_ADD_MENTIONED_USER = 'core/ADD_MENTIONED_USER';

export const addMentionedUser = (user: User) => ({
  type: CORE_ADD_MENTIONED_USER,
  user,
});

